import axios from "axios";
import {baseURL} from "../../helpers/config";


export default axios.create({
    baseURL: baseURL
})